/**
 * @require ./_base.js
 */
(function (global) {
    /**
     * @param options
     * @augments {PopupBase}
     * @constructor
     */
    const ElementPrototypeDiffWindow = function (options) {
        if (!options.ID) {
            options.ID = 'element-prototype-diff';
        }

        if (!options.Title) {
            options.Title = i18next.t('changeMode.elementDiffWindow.title');
        }

        options.ShowOverlay = true;
        options.Width = 1280;
        options.MaxWidth = 1280;
        options.ResizeToFitToContent = true;
        options.Styles = {
            '_': {
                'z-index': 13001
            },
            '.content': {
                padding: '1rem',
                overflow: 'auto'
            },
            '.content-message-bubble': {
                'margin-bottom': '1rem'
            },
            '.gfx-table': {
                width: '100%',
                padding: 0,
                border: '1px solid #ccc',
                'border-radius': '.25rem'
            },
            '.gfx-table input': {
                margin: 0,
                'vertical-align': 'middle'
            },
            '.gfx-table thead th': {
                'text-align': 'left',
                padding: '.5rem',
                'border-bottom': '1px solid #ddd'
            },
            '.gfx-table thead tr:first th:first': {
                'border-top-left-radius': '.25rem'
            },
            '.gfx-table thead tr:first th:last': {
                'border-top-right-radius': '.25rem'
            },
            '.gfx-table tbody tr:nth-child(odd)': {
                'background-color': '#f1f1f1'
            },
            '.gfx-table tbody td': {
                padding: '.5rem',
                'vertical-align': 'top'
            },
            '.gfx-table tbody tr:last th:first': {
                'border-bottom-left-radius': '.25rem'
            },
            '.gfx-table tbody tr:last th:last': {
                'border-bottom-right-radius': '.25rem'
            },
            '.gfx-table tbody ul': {
                'list-style': 'square',
                'padding-left': '1.25rem'
            },
            '.gfx-table tbody ol': {
                'padding-left': '1rem'
            },
            '.gfx-table .hierarchy-info': {
                'margin-top': 0,
                'font-size': '.9rem',
                color: '#999'
            },
        };

        options.Prototypes = options.Prototypes || [];
        options.Properties = options.Properties || [];

        options.Properties.sort(Tools.SortByTitle);

        this.ShowOnlySelectedProperty = true;
        this.SelectedProperties = [];
        this.PrototypeInformation = {
            Raw: { Prototype: [], Derivations: [] },
            Elements: { Prototype: [], Derivations: [] }
        };

        (options.SelectedProperties || []).forEach(property => {
            const preselected = Tools.getFirst(options.Properties, property, 'Attribute');

            if (preselected) {
                this.SelectedProperties.push(preselected);
            }
        });

        global.PopupBase.call(this, options);
    };

    ElementPrototypeDiffWindow.prototype = Object.create(global.PopupBase.prototype);
    ElementPrototypeDiffWindow.prototype.constructor = ElementPrototypeDiffWindow;

    ElementPrototypeDiffWindow.prototype.OnBeforeShow = function () {
        return changemode.element.loadPrototypeInformation(this.options.Element.OID)
            .then((prototypeInformation) => this.PrototypeInformation = prototypeInformation);
    };

    ElementPrototypeDiffWindow.prototype.CreateContentMarkup = function () {
        const columnCount = this.PrototypeInformation.Elements.Prototypes.length + 1;
        const widthPerDiffColumn = 85 / columnCount;

        return DOMPurify.sanitize(`
            <div class="content-message-bubble">
                <div class="content info">
                    <p class="text">
                        ${i18next.t('changeMode.elementDiffWindow.explanation')}
                    </p>
                </div>
            </div>
            <table class="gfx-table">
                <colgroup>
                    <col style="width:3%;">
                    <col style="width:12%;">
                    ${`<col style="width:${widthPerDiffColumn}%;">`.repeat(columnCount)}
                </colgroup>

                <thead>
                    <tr>
                        <th><input type="checkbox" class="select-all"${this.options.Properties.length === 1 ? ' checked' : ''}></th>
                        <th></th>
                        ${this.PrototypeInformation.Elements.Prototypes.map(p => `<th>${p.Title}<p class="hierarchy-info">${Tools.element.createElementHierarchyString(p)}</p></th>`).join('')}
                        <th>${this.options.Element.Title}<p class="hierarchy-info">${Tools.element.createElementHierarchyString(this.options.Element)}</p></th>
                    </tr>
                </thead>

                <tbody>
                    ${this.options.Properties.map(prop => createDiffRow.call(this, prop.Title, prop.Attribute, prop.Type)).join('')}
                </tbody>
            </table>
        `);
    };

    ElementPrototypeDiffWindow.prototype.BindAdditionalEvents = function () {
        this.$content.find('.select-all').on('click', $.proxy(onToggleSelectAll, this));
        this.$content.find('tbody').on('click', '.select-property', $.proxy(onToggleSelectProperty, this));
    };

    ElementPrototypeDiffWindow.prototype.OnAfterRendered = function () {
        if (this.options.Properties.length === 1) {
            this.$bottom.find('.btn-customAction').addClass('hide');
        }

        determineConfirmButtonDisabled.call(this);
    };

    ElementPrototypeDiffWindow.prototype.ToggleShowOnlySelectedProperty = function () {
        this.ShowOnlySelectedProperty = !this.ShowOnlySelectedProperty;

        this.$content.find('tbody tr:not(.is-selected-property)')
            .toggleClass('hide', this.ShowOnlySelectedProperty);

        this.$bottom.find('.btn-customAction').text(
            this.ShowOnlySelectedProperty ?
                i18next.t('changeMode.elementDiffWindow.showAllModifiedProperties') :
                i18next.t('changeMode.elementDiffWindow.showOnlySelectedProperty')
        );

        this.TriggerResize();
    };

    ElementPrototypeDiffWindow.prototype.Ask = function () {
        const $deferred = $.Deferred();
        const elements = [this.options.Element].concat(this.PrototypeInformation.Elements.Derivations).map((element) => {
            return Tools.element.createElementHierarchyString(element, true);
        });

        const options = {
            title: i18next.t('changeMode.elementDiffWindow.confirmation.title'),
            text: i18next.t('changeMode.elementDiffWindow.confirmation.text', { count: this.PrototypeInformation.Elements.Derivations.length + 1 }),
            onNo: () => $deferred.resolve(false),
            onYes: () => {
                const elements = [this.options.Element].concat(this.PrototypeInformation.Elements.Derivations);
                const properties = this.SelectedProperties.map(prop => {
                    prop.Attribute = prop.Attribute.split('|')[0];

                    return prop;
                });

                changemode.element.revertPropertiesToPrototype(elements, properties)
                    .then(function () {
                        $deferred.resolve(true);
                    });
            },
            assignments: elements
        };

        Tools.Message.Show(options);

        return $deferred.promise();
    }

    /**
     * @param {string} title
     * @param {string} attributeName
     * @param {string} attributeType
     * @return {string}
     */
    function createDiffRow(title, attributeName, attributeType) {
        const isSelected = this.options.SelectedProperties instanceof Array &&
            this.options.SelectedProperties.indexOf(attributeName) !== -1;

        return `
            <tr class="${isSelected ? 'is-selected-property' : 'hide'}">
                <td><input type="checkbox" class="select-property" value="${attributeName}"${isSelected ? ' checked' : ''}></td>
                <td>${title}</td>
                ${this.PrototypeInformation.Elements.Prototypes.map(p => `<td class="value-cell">${Tools.element.renderElementAttributeValueToHtml(p, attributeName, attributeType)}</td>`).join('')}
                <td class="value-cell">${Tools.element.renderElementAttributeValueToHtml(this.options.Element, attributeName, attributeType)}</td>
            </tr>
        `;
    }

    function onToggleSelectProperty(evt) {
        const isChecked = evt.currentTarget.checked;
        const attr = evt.currentTarget.value;
        const prop = Tools.getFirst(this.options.Properties, attr, 'Attribute');

        if (prop == null) {
            return;
        }

        if (isChecked) {
            this.SelectedProperties.push(prop);
        } else {
            const idx = Tools.indexOf(this.SelectedProperties, attr, 'Attribute');
            this.SelectedProperties.splice(idx, 1);
        }

        determineConfirmButtonDisabled.call(this);
    }

    function onToggleSelectAll(evt) {
        const isChecked = evt.currentTarget.checked;

        this.$content.find('tbody .select-property').prop('checked', isChecked);
        this.SelectedProperties = isChecked ? this.options.Properties : [];

        determineConfirmButtonDisabled.call(this);
    }

    function determineConfirmButtonDisabled() {
        if (this.SelectedProperties.length === 0) {
            this.$bottom.find('.btn-yes').attr('disabled', 'disabled');
        } else {
            this.$bottom.find('.btn-yes').removeAttr('disabled');
        }
    }

    global.ElementPrototypeDiffWindow = ElementPrototypeDiffWindow;
})(Modifications.Popups || (Modifications.Popups = {}));